export const testData = {
  bean: {
    total: 0
  },
  beans: [],
  object: [
    {
      childList: [
        {
          childList: [
            {
              childList: [],
              id: '7',
              name: '融合模型',
              parentId: '2'
            },
            {
              childList: [
                {
                  childList: [
                    {
                      id: '10',
                      name: 'B域1111',
                      parentId: '9'
                    }
                  ],
                  id: '9',
                  name: 'B域',
                  parentId: '8'
                }
              ],
              id: '8',
              name: '基础模型',
              parentId: '2'
            }
          ],
          id: '2',
          name: '主题',
          parentId: '1'
        },
        {
          childList: [],
          id: '3',
          name: '层次',
          parentId: '1'
        },
        {
          childList: [],
          id: '4',
          name: '系统',
          parentId: '1'
        },
        {
          childList: [],
          id: '5',
          name: '数据库',
          parentId: '1'
        },
        {
          childList: [],
          id: '6',
          name: '部门',
          parentId: '1'
        }
      ],
      id: '1',
      name: '数据架构定义',
      parentId: ''
    }
  ],
  returnCode: '0',
  returnMessage: '0',
  totalCount: 0
};
